import { Component, Input, OnInit } from '@angular/core';
import { GetTicketsInput, Result, TableAction, TableCode, TicketResult } from 'app/models';
import { TicketService } from 'app/services';
import { Utility } from 'app/shared/utility';

@Component({
  selector: 'app-ticket-assigned-employee',
  templateUrl: './ticket-assigned-employee.component.html',
  styleUrls: ['./ticket-assigned-employee.component.scss']
})
export class TicketAssignedEmployeeComponent implements OnInit {

  public getTicketsInput = new GetTicketsInput();
  public result = new Result();
  public token = Utility.getTokenType();
  public ticketResult :TicketResult[] = [];
  public tableCode = TableCode;
  public tableAction = TableAction;
  i:number=0;


  @Input()
  isBusy = false;

  @Input()
  public set id(value: number) {

    this.getTicketsInput.customerId = value;

    if (this.isBusy === false && value !== 0) {
      this.isBusy = true;

      this.ticketService.getTickets(this.getTicketsInput, this.token).then(result => {
        this.isBusy = false;

        if (result.success === true) {
          result.data.forEach(item=>{
            this.i=0;
            //boş olanları getirmemek için
            if (item.assignedEmployeeFullName!="")
            {
              if (this.ticketResult.length!=0) {
                //o kişi varsa bir daha eklenmesin : 
                this.ticketResult.forEach(item2=>{
                  if(item2.assignedEmployeeFullName == item.assignedEmployeeFullName)
                   this.i=1;
               })
               if (this.i==0) {
                this.ticketResult.push(item);
               }
              }
              else this.ticketResult.push(item);
            }
              
            })
            console.log("deneme : " + this.ticketResult);
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  constructor(private ticketService: TicketService) { }

  ngOnInit(): void {
  }

}
